import adminApi from '@/apis/admin'

export default {
  state: {
    scenarios: [],
    loading: false
  },
  mutations: {
    SET_ADMIN_SCENARIOS(state, list) {
      state.scenarios = list || []
    },
    SET_ADMIN_SCENARIOS_LOADING(state, loading) {
      state.loading = !!loading
    }
  },
  actions: {
    async fetchAdminScenarios({ commit }) {
      commit('SET_ADMIN_SCENARIOS_LOADING', true)
      try {
        const resp = await adminApi.listScenarios()
        const body = resp.data || {}
        if (body.success) commit('SET_ADMIN_SCENARIOS', body.data.scenarios || [])
        return body
      } finally {
        commit('SET_ADMIN_SCENARIOS_LOADING', false)
      }
    },
    async toggleAdminScenario({ dispatch }, { id, enabled }) {
      const fn = enabled ? adminApi.enableScenario : adminApi.disableScenario
      const resp = await fn(id)
      await dispatch('fetchAdminScenarios')
      return resp.data
    },
    async createAdminScenario({ dispatch }, payload) {
      const resp = await adminApi.createScenario(payload)
      await dispatch('fetchAdminScenarios')
      return resp.data
    },
    async updateAdminScenario({ dispatch }, { id, payload }) {
      const resp = await adminApi.updateScenario(id, payload)
      await dispatch('fetchAdminScenarios')
      return resp.data
    },
    async deleteAdminScenario({ dispatch }, id) {
      const resp = await adminApi.deleteScenario(id)
      await dispatch('fetchAdminScenarios')
      return resp.data
    }
  }
}
